<template>
  <div>
    <v-row v-for="product in productList" :key="product.name" style="flex-wrap: nowrap">
      <v-col cols="5" align-self="center">
        <a-truncate :text="product.name" :hoverText="product.hoverName" />
      </v-col>
      <v-col cols="3" align-self="center">
        <HotelPriceHover
          v-if="showPriceBreakdown"
          :text="product.rate"
          :taxInclusive="product.tax_inclusive"
          :tax="product.tax"
          :supplierMeta="supplierMeta"
          :meta="product.meta"
          :bookingSupplierMeta="data.meta"
          :original="product.original"
          :showConvert="showConverstion"
          :convert="product.convert"
          :quotePrice="product.quotePrice"
        />
        <OtherPriceHover v-else :original="product.rate" :text="product.rate" :quotePrice="product.quotePrice" />
      </v-col>
      <v-col cols="2" align-self="center" v-if="showHotelPorterage()">
        <HotelPorterageHover :porterage="data.meta.supplier_meta?.porterage" />
      </v-col>
      <v-col class="pt-1" align-self="center" v-if="product.showCount">
        <ConfirmCount
          :outside="outside"
          :typeAs="typeAs"
          :status="data.status"
          :date="date"
          :bookingSupplierMeta="data.meta"
          :productId="product.id"
          :productCount="product.count"
          :pax="pax"
          :supcount="supcount"
          :products="data.products"
          @synccount="syncCount"
          @confirm="confirmCount"
        >
          <RestaurantCountHover v-if="showRestaurantCount()" :count="product.count" :supcount="supcount" />
          <ExcursionCustomCountHover v-else-if="showExtraExcursion" :count="product.count" :supcount="supcount" />
          <span class="caption" v-else>{{ product.count }}</span>
        </ConfirmCount>
      </v-col>

      <slot></slot>
    </v-row>
  </div>
</template>

<script>
import { ProductService } from "@/modules/products";
import moneyService from "@/services/money";
import DateFormat from "@/services/format";
import HotelPriceHover from "./_HotelPriceHover";
import OtherPriceHover from "./_OtherPriceHover";
import HotelPorterageHover from "./_HotelPorterageHover.vue";
import RestaurantCountHover from "./_RestaurantCountHover";
import ExcursionCustomCountHover from "./_ExcursionCustomCountHover";
import ConfirmCount from "./_ConfirmCount";
import bookingsDaysUtils from "@/modules/bookings.days/components/utils";
export default {
  props: {
    outside: Boolean,

    typeAs: String,
    data: Object, // Supplier + product information
    date: String,
    confirmed: Boolean,
    pax: Number,
    customPrices: Object, // Mapping for products with custom pricing
    customPricesV2: Object,
    supcount: [Array, Object],
    showExtraExcursion: Boolean,
  },
  components: {
    HotelPriceHover,
    HotelPorterageHover,
    RestaurantCountHover,
    ExcursionCustomCountHover,
    ConfirmCount,
    OtherPriceHover,
  },
  computed: {
    productList() {
      var t = [];
      if (this.data.products) {
        let name, price, refkey, count, groupFit, product, quotePrice;
        const vm = this;
        Object.keys(this.data.products).forEach((key) => {
          product = vm.data.products[key];
          price = this.rateContent(vm.data.products[key]);
          count = this.data.meta && this.data.meta.count && this.data.meta.count[key];
          name = this.data.meta && this.data.meta.custom_names && this.data.meta.custom_names[key];
          groupFit = vm.data.products[key].group_fit;
          quotePrice = this.data.meta && this.data.meta.quote_price && this.data.meta.quote_price[key];

          this.syncMetaCostsWithProductCurrency(vm.data.products[key]);

          t.push({
            id: product.id,
            name: `${name || vm.data.products[key].name}`,
            hoverName: `${name || vm.data.products[key].name} (${groupFit})`,
            rate: price.rate,
            convert: price.convert,
            count: count != null ? count : 1,
            original: price.original,

            tax_inclusive: product.tax_inclusive,
            tax: product.meta?.custom_tax || this.data.meta?.supplier_meta?.tax || null,
            meta: product.meta,

            showCount: (() => {
              if (vm.data.products[key].product_type === "EXPENSE") return true;
              return !["HOTEL", "TOUR_GUIDE"].includes(this.typeAs);
            })(),

            quotePrice: quotePrice != null ? ProductService.formatPrice(quotePrice) : null,
          });
        });
      }
      return t;
    },
    productListLabel() {
      return this.productList.length ? this.productList.map((x) => x.name).join(", ") : "";
    },
    showConverstion() {
      return this.$store.getters["AccountStore/environment"] !== "USA";
    },
    showCount() {
      return !["HOTEL", "TOUR_GUIDE"].includes(this.typeAs);
    },
    showPriceBreakdown() {
      return ["HOTEL"].includes(this.typeAs);
    },
    supplierMeta() {
      return this.data.supplier_meta || {};
    },
    showConfirmCount() {
      return ["EXCURSION"].includes(this.typeAs);
    },
    bookingData() {
      return this.$store.getters["BookingStore/data"];
    },
  },
  methods: {
    syncMetaCostsWithProductCurrency(product) {
      const meta = product.meta;
      if (!meta) return meta;

      let currency;
      if (product.seasonal === 1) {
        const defaultType = product.rate[0].rate.type === "PROOM" ? "DOUBLE_QK" : "DEFAULT";
        const emptyPriceIndex = product.rate.findIndex((p) => p.roomType == null || p.roomType === "");
        const defaultPriceIndex = product.rate.findIndex((p) => p.roomType === defaultType);

        const index = defaultPriceIndex !== -1 ? defaultPriceIndex : emptyPriceIndex !== -1 ? emptyPriceIndex : -1;
        if (index === -1) return meta;

        currency = product.rate[index].rate.cur;
      } else {
        currency = product?.rate?.cur;
      }

      const extraKeys = Object.keys(meta).filter((key) => key.includes("extra_"));
      for (const extraKey of extraKeys) {
        const extra = meta[extraKey];
        if (extra.astype !== "COST") continue;
        // TODO: check this why currency is not same with product currency
        // if (value.cur === currency) continue;
        // const isUsdToCad = value.cur === "USD" && currency === "CAD";
        // const isCadToUsd = value.cur === "CAD" && currency === "USD";

        if (currency === "CAD") {
          extra.value.cur = "CAD";
        }
      }

      return meta;
    },
    rateContent(product) {
      let locked = this.data.locked_prices && this.data.locked_prices[product.id];
      const useDates = this.data.meta && this.data.meta.use_dates;
      let dateDefault = {
        from_month: DateFormat.dateToObj(this.date).month,
        from_day: DateFormat.dateToObj(this.date).day,
      };
      const price = ProductService.getPrice(
        product,
        this.data.supplier_meta,
        this.data.country,
        this.customPrices,
        this.customPricesV2,
        this.$store.getters,
        true,
        useDates || dateDefault,
        this.data.meta
      );

      if (!product.seasonal) {
        return {
          rate: locked ? ProductService.formatPrice(locked.totalPrice) : price.totalPrice_print,
          convert:
            locked && locked.totalConvert
              ? ProductService.formatConvert(locked.totalConvert)
              : price.totalConvert_print,
          original:
            locked && locked.originalPrice ? ProductService.formatPrice(locked.originalPrice) : price.price_print,
        };
      }

      const defaultType = product.rate[0].rate.type === "PROOM" ? "DOUBLE_QK" : "DEFAULT";
      const emptyPriceIndex = price.findIndex((p) => p.roomType == null || p.roomType === "");
      const defaultPriceIndex = price.findIndex((p) => p.roomType === defaultType);
      const index = defaultPriceIndex !== -1 ? defaultPriceIndex : emptyPriceIndex !== -1 ? emptyPriceIndex : -1;

      if (index == -1) return {};

      const p = price[index];
      locked =
        this.data.locked_prices && this.data.locked_prices[product.id] && this.data.locked_prices[product.id][index];

      return {
        rate: locked ? ProductService.formatPrice(locked.totalPrice) : p.totalPrice_print,
        convert:
          locked && locked.totalConvert ? ProductService.formatConvert(locked.totalConvert) : p.totalConvert_print,
        original: locked && locked.originalPrice ? ProductService.formatPrice(locked.originalPrice) : p.price_print,
      };
    },

    syncCount({ product_id, date, confirmCount }) {
      let nuCountMapping = { ...((this.data.meta && this.data.meta.confirmed_count_total) || {}) };
      if (!nuCountMapping[product_id]) nuCountMapping = { [product_id]: { [date]: confirmCount } };

      nuCountMapping[product_id][date] = confirmCount;

      this.$emit("syncmeta", { key: "confirmed_count_total", count: nuCountMapping });
    },
    confirmCount() {
      this.$emit("syncmeta", { key: "confirmed_offcount", value: true });
    },
    showHotelPorterage() {
      return this.typeAs === "HOTEL" && !bookingsDaysUtils.isProductRateTypeGroup(this.data.products);
    },
    showRestaurantCount() {
      return this.typeAs === "RESTAURANT" && !bookingsDaysUtils.isProductRateTypeGroup(this.data.products);
    },
  },
};
</script>
